__turbopack_context__.v({
  "afterFooter": "Footer-module__h_ceZa__afterFooter",
  "description": "Footer-module__h_ceZa__description",
  "footer": "Footer-module__h_ceZa__footer",
  "groups": "Footer-module__h_ceZa__groups",
  "inner": "Footer-module__h_ceZa__inner",
  "link": "Footer-module__h_ceZa__link",
  "logo": "Footer-module__h_ceZa__logo",
  "name": "Footer-module__h_ceZa__name",
  "social": "Footer-module__h_ceZa__social",
  "title": "Footer-module__h_ceZa__title",
  "wrapper": "Footer-module__h_ceZa__wrapper",
});
